export default __webpack_public_path__ + "static/media/product-selector.723d67d6.svg";